import StreetAddress from 'app/shared/model/StreetAddress';

const AddressDetails = ({
    zpid = '',
    beds = '',
    baths = '',
    geo = {},
    livingArea = '',
    homeType = '',
    streetAddress = {},
    propertyTypeCode = '',
    roomCount = '',
    rentZestimate = '',
    lotArea = '',
} = {}) => ({
    zpid: String(zpid),
    beds: Number(beds),
    baths: Number(baths),
    geo: Object(geo),
    livingArea: Number(livingArea),
    homeType: String(homeType),
    streetAddress: StreetAddress(streetAddress),
    propertyTypeCode: Number(propertyTypeCode),
    roomCount: Number(roomCount),
    rentZestimate: Number(rentZestimate),
    lotArea: Number(lotArea),
});

export default AddressDetails;
